"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChildForm = void 0;

var _vuePropertyDecorator = require("vue-property-decorator");

var _vueJsonView = require("vue-json-view");

require("./index.less");

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _temp;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var ele2VNode = _vueJsonView.VueJsonView.ele2VNode;
var getDataByName = _vueJsonView.Utils.getDataByName,
    setDataByObj = _vueJsonView.Utils.setDataByObj;
var ChildForm = (_dec = (0, _vuePropertyDecorator.Component)({
  components: {
    MhFormItem: _vueJsonView.MhFormItem
  }
}), _dec2 = (0, _vuePropertyDecorator.Inject)(), _dec3 = (0, _vuePropertyDecorator.Prop)(), _dec4 = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return [];
  }
}), _dec5 = (0, _vuePropertyDecorator.Prop)(), _dec6 = (0, _vuePropertyDecorator.Prop)(), _dec7 = (0, _vuePropertyDecorator.Prop)({
  default: true
}), _dec8 = (0, _vuePropertyDecorator.Prop)({
  default: 9999
}), _dec9 = (0, _vuePropertyDecorator.Prop)({
  default: 0
}), _dec10 = (0, _vuePropertyDecorator.Prop)(), _dec11 = (0, _vuePropertyDecorator.Prop)(), _dec12 = (0, _vuePropertyDecorator.Prop)(), _dec13 = (0, _vuePropertyDecorator.Watch)('initData', {
  immediate: true,
  deep: true
}), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  _inherits(ChildForm, _Vue);

  var _super = _createSuper(ChildForm);

  function ChildForm() {
    var _this;

    _classCallCheck(this, ChildForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_this, "form", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "name", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "elements", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "deleteElement", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "addElement", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "showTitle", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "maxNum", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "minNum", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "label", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "addText", _descriptor10, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "deleteText", _descriptor11, _assertThisInitialized(_this));

    _this.list = [true];
    return _this;
  }

  _createClass(ChildForm, [{
    key: "initDataChange",
    value: function initDataChange() {
      var name = this.name,
          form = this.form;
      var initData = form.attrs.initData;

      if (name && initData) {
        var temp = getDataByName(initData, name);

        if (temp && Array.isArray(temp)) {
          this.list = temp.map(function (t) {
            return !!t;
          });
        }
      }
    }
  }, {
    key: "deleteBlock",
    value: function deleteBlock(i) {
      if (this.form) {
        var list = (getDataByName(setDataByObj({}, this.form.getValues()), this.name) || []).slice();
        list.splice(i, 1);
        this.form.context.emitChange(_defineProperty({}, this.name, list));
      }

      this.$set(this.list, i, false);
    }
  }, {
    key: "render",
    value: function render(h) {
      var _this2 = this;

      var showTitle = this.showTitle,
          name = this.name,
          list = this.list,
          label = this.label,
          elements = this.elements,
          deleteElement = this.deleteElement,
          addElement = this.addElement,
          realLength = this.realLength,
          minNum = this.minNum,
          maxNum = this.maxNum;
      return h("div", {
        "class": "mh-child-form mh-form-item"
      }, [h("div", {
        "class": {
          'mh-form-item-label': true
        }
      }, [label && h("label", [label])]), h("div", {
        "class": "mh-form-item-control-wrapper"
      }, [h("div", {
        "class": "mh-form-item-table-wrapper"
      }, [h("table", {
        "class": "mh-child-form-table"
      }, [showTitle && h("tr", {
        "class": "mh-child-form-title"
      }, [elements.map(function (item) {
        return h("th", {
          "key": item.name
        }, [h("div", {
          "class": {
            'mh-form-item-label-required': item.required
          }
        }, [h("label", [item.label])])]);
      }), h("th", {
        "style": "min-width: 50px;"
      })]), list.map(function (b, i) {
        return b && h("tr", {
          "key": i,
          "class": "mh-child-form-item"
        }, [elements.map(function (item) {
          return h("td", [ele2VNode(h, _objectSpread(_objectSpread({}, item), {}, {
            name: "".concat(name, "[").concat(i, "]").concat(item.name || ''),
            label: ''
          }))]);
        }), h("td", {
          "style": "vertical-align: middle; padding: 6px; min-width: 50px;"
        }, [h("a", {
          "on": {
            "click": function click() {
              return _this2.deleteBlock(i);
            }
          }
        }, [_this2.deleteText || '删除'])])]);
      })])]), realLength < maxNum && h("div", {
        "style": "margin-top: 6px;"
      }, [h("a", {
        "on": {
          "click": function click() {
            return list.push(true);
          }
        }
      }, [this.addText || '添加'])])])]);
    }
  }, {
    key: "realLength",
    get: function get() {
      return this.list.filter(function (b) {
        return b;
      }).length;
    }
  }], [{
    key: "install",
    value: function install(context) {
      context.component('mh-child-form', this);
    }
  }]);

  return ChildForm;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "form", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "elements", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "deleteElement", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "addElement", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "showTitle", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "maxNum", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "minNum", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "addText", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "deleteText", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "initDataChange", [_dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "initDataChange"), _class2.prototype)), _class2)) || _class);
exports.ChildForm = ChildForm;